import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 0 16px 16px;
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
`;

export const Description = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  margin: 0;
  width: 70%;

  span svg {
    margin-top: -2px;
    color: #8277f8;
    width: 16px;
    height: 16px;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const FinishButton = styled(AntdButton)`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
`;
